import { Card, CardBody, Col, FormGroup, Input, Label, Table } from "reactstrap";
import { Link } from "react-router-dom";
import CommonCardHeader from "../../../Utils/CommonComponents/CommonCardHeader/CommonCardHeader";
import { H5, Image, ProgressBar } from "../../../AbstractElements";
import { dynamicImage } from "../../../Utils";
import { monthlyDropdownList, productRevenueTableData } from "../../../Data/Dashboard/Default";

const ProductRevenue = () => {
  return (
    <Col xxl="7" className="box-col-12">
      <Card>
        <CommonCardHeader headClass="pb-0 card-no-border" mainTitle dropDownList={monthlyDropdownList} title={"Product Revenue"} />
        <CardBody className="sales-product pt-0">
          <div className="table-responsive theme-scrollbar">
            <div className="dataTables_wrapper no-footer">
              <div id="sale-product_filter" className="dataTables_filter">
                <label> Search: <input type="search" /></label>
              </div>
              <Table className="display dataTable no-footer" id="sale-product" style={{ width: "100%" }} role="grid">
                <thead>
                  <tr role="row">
                    <th className="sorting_asc" tabIndex={0} aria-controls="sale-product" rowSpan={1} colSpan={1} aria-sort="ascending" aria-label=": activate to sort column descending" style={{ width: "35.5156px" }}>
                      <FormGroup check>
                        <Input type="checkbox" defaultValue="" />
                        <Label check />
                      </FormGroup>
                    </th>
                    <th className="sorting" tabIndex={0} aria-controls="sale-product" rowSpan={1} colSpan={1} aria-label="Name: activate to sort column ascending" style={{ width: "227.203px" }}>
                      Name
                    </th>
                    <th className="sorting" tabIndex={0} aria-controls="sale-product" rowSpan={1} colSpan={1} aria-label="Date: activate to sort column ascending" style={{ width: "107.938px" }}>
                      Date
                    </th>
                    <th className="sorting" tabIndex={0} aria-controls="sale-product" rowSpan={1} colSpan={1} aria-label="Amount: activate to sort column ascending" style={{ width: "72.7031px" }}>
                      Amount
                    </th>
                    <th className="sorting" tabIndex={0} aria-controls="sale-product" rowSpan={1} colSpan={1} aria-label="% Sold: activate to sort column ascending" style={{ width: "67.6875px" }}>
                      % Sold
                    </th>
                    <th className="sorting" tabIndex={0} aria-controls="sale-product" rowSpan={1} colSpan={1} aria-label="Progressbar: activate to sort column ascending" style={{ width: "111.531px" }}>
                      Progressbar
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {productRevenueTableData.map((item) => (
                    <tr role="row" className="even" key={item.id}>
                      <td className="sorting_1">
                        <FormGroup check>
                          <Input type="checkbox" defaultValue="" />
                          <Label check />
                        </FormGroup>
                      </td>
                      <td>
                        <div className="d-flex align-items-center">
                          <div className="flex-shrink-0">
                            <Image src={dynamicImage(`dashboard/product/${item.imageSrc}`)} alt='' />
                          </div>
                          <div className="flex-grow-1">
                            <Link to={`${process.env.PUBLIC_URL}/ecommerce/product_list`}>
                              <H5>{item.name}</H5>
                            </Link>
                          </div>
                        </div>
                      </td>
                      <td>{item.date}</td>
                      <td>{item.amount}</td>
                      <td>{item.percentSold}</td>
                      <td>
                        <ProgressBar className={`b-r-2 progress-striped-${item.color}`} value={item.progressBarWidth} />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};
export default ProductRevenue;
